/***
*
*   FOOTER (homepage)
*   Static homepage footer
*
**********/

import React from 'react';
import { Animate, Row, Content, Link } from 'components/lib'
import Style from './footer.module.scss';

export function Footer(props){

  return (
    <Animate type='slideup'>
      <footer className={ Style.footer }>
        <Row>
          <Content>

            <nav>
            <Link url='/' text='Página de Inicio'/>
            <Link url='/pricing' text='Precio'/>
            <Link url='/signin' text='Ingresar'/>
            <Link url='/signup' text='Registrarse'/>
            <Link url='/terms' text='Términos'/>
            <Link url='/privacy' text='Políticas de Privacidad'/>
            <Link url='/contact' text='Contactos'/>
            </nav>

            <span>{ `Copyright © Deal Finder ${new Date().getFullYear()}`}</span>
            {/* <address>Hidalgo de Pinto N40-960. Quito (Ecuador)</address> */}

          </Content>
        </Row>
      </footer>
    </Animate>
  );
}
